import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';
import { useStore } from './StoreContext';

const SocketContext = createContext(null);
export const useSocket = () => useContext(SocketContext);

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL ||
  'https://api.boltin.com';

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { tillId, getCurrentTillForStore } = useAuth();
  const { activeStore } = useStore();
  const currentTillId = activeStore?._id ? getCurrentTillForStore(activeStore._id) : tillId;

  useEffect(() => {
    const newSocket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
    });
    setSocket(newSocket);

    return () => newSocket.close();
  }, []);

  useEffect(() => {
    if (!socket) return;
    const handleConnect = () => {
      if (currentTillId) {
        socket.emit('register_till', currentTillId);
      } else {
        socket.emit('unregister_till');
      }
    };
    socket.on('connect', handleConnect);
    return () => socket.off('connect', handleConnect);
  }, [socket, currentTillId]);

  useEffect(() => {
    if (!socket?.connected) return;

    if (currentTillId) {
      socket.emit('register_till', currentTillId);
    } else {
      socket.emit('unregister_till');
    }
  }, [socket, currentTillId]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
